const LoadingDotsIcon = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.7866 2.33301C16.8266 2.33301 13.6133 5.54634 13.6133 9.50634C13.6133 13.4663 16.8266 16.6797 20.7866 16.6797C24.7466 16.6797 27.9599 13.4663 27.9599 9.50634C27.9599 5.54634 24.7466 2.33301 20.7866 2.33301Z"
        fill="#0CAE5C"
      />
      <path
        opacity="0.4"
        d="M8.48006 17.375C7.60229 17.3753 6.7443 17.6358 6.01457 18.1236C5.28484 18.6114 4.71613 19.3047 4.38034 20.1157C4.04456 20.9267 3.95677 21.819 4.12808 22.6799C4.29939 23.5408 4.7221 24.3316 5.34278 24.9523C5.96346 25.573 6.75423 25.9957 7.61513 26.167C8.47602 26.3383 9.36838 26.2505 10.1794 25.9147C10.9904 25.5789 11.6836 25.0102 12.1715 24.2805C12.6593 23.5508 12.9198 22.6928 12.9201 21.815C12.9201 19.3617 10.9201 17.375 8.48006 17.375ZM22.1601 22.1617C20.0934 22.1617 18.4134 23.8417 18.4134 25.9083C18.4134 27.975 20.0934 29.655 22.1601 29.655C24.2267 29.655 25.9067 27.975 25.9067 25.9083C25.9067 23.8417 24.2267 22.1617 22.1601 22.1617Z"
        fill="#0CAE5C"
      />
    </svg>
  );
};

export default LoadingDotsIcon;
